import state from "../vuex/state";
import Vue from 'vue'
import Router from 'vue-router'

import Homepage from '../views/Homepage'
import Help from '../views/Help'
import Support from '../views/Support'
import DebuggingTools from '../views/DebuggingTools'
import Api from '../views/Api'


Vue.use(Router)

let abc = new Router({
  menuList: [],
  mode: 'history',
  saveScrollPosition: false,
  routes: [{
    path: '/',
    name: 'index',
    component: Homepage
  },{
    path: '/404',
    name: '404',
    redirect: '/'
  },
    {
      path: '/Homepage',
      name: 'Homepage',
      component: Homepage
    },
    {
      path: '/Help',
      name: 'Help',
      component: Help
    },
    {
      path: '/Support',
      name: 'Support',
      component: Support
    },
    {
      path: '/DebuggingTools',
      name: 'DebuggingTools',
      component: DebuggingTools
    },
  ]
})

function foreach(item, arr) {
  item.forEach(function (sub, subIndex) {
    if (sub.sub.length === 0) {
      let obj = {
        path: sub.linkUrl,
        name: sub.linkUrl,
        component: function (resolve) {
          resolve(require('../components/Doc/' + sub.path + sub.linkUrl + '.vue'));
        },
        meta: sub.linkUrl
      };
      arr.push(obj);
    } else {
      foreach(sub.sub, arr)
    }
  })
}


fetch("../static/config/vue.config.json")
.then(res => res.json())
.then(data => {
//获取到了数据
  console.log('从配置文件获取菜单路由')
  addMenuRoutes(data.menuList)
})
.catch(err=>{
//解析错误或者获取数据失败
  console.log('从配置文件获取菜单err: ' + err)
  addMenuRoutes(state.menuList)
})

// 遍历菜单添加到路由
function addMenuRoutes(menuList) {
  menuList.forEach(function (ele, index) {
    let arr = []
    ele.menu.forEach(function (sub, index2) {
      if (sub.path === undefined) {
        sub.path = ''
      }
      if (sub.sub.length === 0) {
        if (index2 === 0) {
          let obj = {
            path: ele.index,
            name: ele.index,
            component: function (resolve) {
              resolve(require('../components/Doc/' + sub.linkUrl + '.vue'));
            },
            meta: sub.linkUrl
          };
          arr.push(obj);
        }
        let obj = {
          path: sub.linkUrl,
          name: ele.desc + '-' + sub.linkUrl,
          component: function (resolve) {
            resolve(require('../components/Doc/' + sub.linkUrl + '.vue'));
          },
          meta: sub.linkUrl
        };
        arr.push(obj);
      } else {
        foreach(sub.sub, arr)
      }
    })
    abc.menuList = menuList
    abc.addRoutes([{
      path: ele.index,
      name: ele.desc,
      query: {t:Date.now()},
      component: Api,
      children: arr
    }])
  })
}

export default abc



// WEBPACK FOOTER //
// ./src/router/index.js